<div class="voxel-container-md" [ngClass]="headerClass">
    <div class="portal-header-link">
      <button voxelButtonAction (click)="closeApp()">
        {{closeText}}
      </button>
      <voxel-icon type="secondary" (click)="closeApp()" class="ico">fechar</voxel-icon>
    </div>
    <h2 class="header-title">{{headerTitle}}</h2>
  </div>
<div class="voxel-container-md container-padding">

  <p class="header-subtitle" *ngIf="CONTENT_BOUNDS?.section?.header?.subtitle">{{CONTENT_BOUNDS?.section?.header?.subtitle}}</p>

  <!-- <h3 class="title-text" voxelHeaderTitle>{{CONTENT_BOUNDS?.section.home_title}}</h3> -->
</div>
<div class="voxel-container-md container-padding">
  <div class="voxel-row">
    <div class="card-info voxel-col-4 voxel-col-xs-2 voxel-col-sm-4 voxel-col-md-6" *ngFor="let type of CONTENT_BOUNDS?.section.solicitation_type">
      <div class="voxel-card card-img">
        <img class="voxel-mb-0" src="assets/img/fiducial-bank/{{type.image}}" alt="error_img" id="imgSuccess">
      </div>
      <div class="voxel-card card-body">
        <div class="card-title">
          <h4 class="voxel-text-section-02">{{type.name}}</h4>
          <p class="voxel-text-body-01">
            {{type.description}}
          </p>
        </div>
        <div class="voxel-row">
          <button voxelButton class="voxel-col-12 voxel-col-sm-12 voxel-col-md-12" (click)="navigateTo(type.app)">{{type.button_name}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div style="display:none" *ngIf="app.currentApplication == 'fiducial'">
  <app-steps-information-modal #modalStepsInformation></app-steps-information-modal>
</div>